export function generateMapUrl(lon: number, lat: number, name:string|undefined, address:string|undefined){
  if (name || address) {
    let location = name ? `${name},${address}` : address;
    return `https://www.google.com/maps/search/${location}/@${lat},${lon},17z`;
  } else {
    return `http://www.google.com/maps/place/${lat},${lon}`;
  }
}

export function generateMapPictureUrl(lon: number, lat: number, key = googleApiKey()){
  return `https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lon}&zoom=15&size=330x185&maptype=roadmap&markers=color:red%7C${lat},${lon}&key=${key}`;
}

export function googleApiKey(){
  return 'AIzaSyCEk4b-RZe0JtMXeNtb5Y_iYErEqkslDO4';
}